import React, { useEffect, useState } from "react";
import SectionContainer from "../../../Homepage/SectionContainer";
import { Col, Container, Row } from "reactstrap";

import banner from "../../../assets/kangaroo/ieltsprep.png";

import { useLocation, useNavigate } from "react-router-dom";
import FormGoldBg from "../../../component/FormCloseGold/FormGoldBg";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import InlineForm from "../../../component/InlineForm/InlineForm";
import DynamicInlineForm from "../../../component/DynamicInline/DynamicInlineForm";
import axios from "axios";
import TestPreparationService from "../../../services/TespreparationService";
import { useQuery } from "@tanstack/react-query";
import { imageBaseApi } from "../../../services/imageBaseApi";
import PageService from "../../../services/PageService";
import WidgetsService from "../../../services/WidgetsService";
import { Link2, Loader } from "lucide-react";
import Cover404 from "../../../common/Cover404";

const TestPreparation = () => {

  const [hoveredId, setHoveredId] = useState(null);


  const { pathname } = useLocation();
  const slug = pathname.split("/").filter(Boolean).pop();
  console.log("🚀 ~ TestPreparation ~ slug:", slug)


  const enumMap = {
    "test-preparation": 2,
    "travel": 3,
    "oshc": 4,
  };



  const widgetType = enumMap[slug];



  // const slug = "etst"

  const fetchTestPreparation = async (slug) => {
    const response = await PageService.getbySlug(slug)
    return response;
  };

  const { data: testPrepData, isFetched, isLoading } = useQuery({
    queryKey: ["test-preparationss", slug],
    queryFn: () => fetchTestPreparation(slug),

  });



  const fetchWidgets = async () => {
    const response = await WidgetsService.getHomeWidgets(enumMap[slug]);
    return response;
  };

  const { data: WidgetData, isPending: WidgetPending, error: WidgetError } = useQuery({
    queryKey: ['WidgetData', widgetType],
    queryFn: fetchWidgets,
  })

  const renderWidgetContent = (htmlContent) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;

    return Array.from(tempDiv.children).map((child, index) => {
      if (child.tagName === "H1") {
        return (
          <Row key={index} >
            <Col>
              <h1 className="font-level-4 lh-1" style={{ marginTop: "2rem" }}>{child.textContent}</h1>
            </Col>
          </Row>
        );
      }

      if (child.tagName === "H2") {
        return (
          <Row key={index} >
            <Col>
              <h1 className="font-level-8" style={{ marginTop: "2rem" }}>{child.textContent}</h1>
            </Col>
          </Row>
        );
      }

      if (child.tagName === "H3") {
        return (
          <Row key={index} >
            <Col>
              <h1 className="font-level-1" style={{ marginTop: "2rem" }}>{child.textContent}</h1>
            </Col>
          </Row>
        );
      }



      if (child.tagName === "P" && child.textContent.trim()) {
        return (
          <Row key={index}>
            <Col>
              <p
                className="country-paragraph-text mb-3"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      if (child.tagName === "UL") {
        return (
          <Row key={index}>
            <Col>
              <ul
                className="country-paragraph-text mb-3"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      if (child.tagName === "OL") {
        return (
          <Row key={index}>
            <Col>
              <ol
                className="country-paragraph-text mb-3"
                dangerouslySetInnerHTML={{
                  __html: child.innerHTML,
                }}
              />
            </Col>
          </Row>
        );
      }

      return null;
    });
  };


  const renderContent = (htmlContent) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;

    const links = tempDiv.querySelectorAll("a");
    links.forEach((link) => {
      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");
    });

    return Array.from(tempDiv.children).map((child, index) => {
      if (child.tagName === "H1") {
        return <h1 key={index} className="font-level-4 mt-4">{child.textContent}</h1>;
      }
      if (child.tagName === "IMG") {
        return (
          <img
            key={index}
            src={child.getAttribute("src")}
            alt={child.getAttribute("alt") || ""}
            style={{ maxWidth: "100%", height: "auto" }}
          />
        );
      }

      if (child.tagName === "H2") {
        return <h2 key={index} className="font-level-8 mt-4">{child.textContent}</h2>;
      }

      if (child.tagName === "H3") {
        return <h3 key={index} className="font-level-8 mt-4" style={{ fontSize: "24px" }}>{child.textContent}</h3>;
      }

      if (child.tagName === "H4") {
        return <h4 key={index} className="font-level-8  mt-4" style={{ fontSize: "20px" }}>{child.textContent}</h4>;
      }

      if (child.tagName === "P") {
        return (
          <p
            key={index}
            className="country-paragraph-text mb-3"
            dangerouslySetInnerHTML={{ __html: child.innerHTML }}
          />
        );
      }

      if (child.tagName === "UL") {
        return (
          <ul
            key={index}
            className="country-paragraph-text mb-3"
            dangerouslySetInnerHTML={{ __html: child.innerHTML }}
          />
        );
      }

      if (child.tagName === "OL") {
        return (
          <ol
            key={index}
            className="country-paragraph-text mb-3"
            dangerouslySetInnerHTML={{ __html: child.innerHTML }}
          />
        );
      }

      if (child.tagName === "FIGURE" && child.querySelector("table")) {
        return (
          <div key={index} className="table-responsive my-4">
            <table
              className="table table-bordered"
              dangerouslySetInnerHTML={{
                __html: child.querySelector("table").innerHTML,
              }}
            />
          </div>
        );
      }

      if (child.tagName === "FIGURE" && child.querySelector("img")) {
        const img = child.querySelector("img");
        const src = img.getAttribute("src");

        // Skip images without src
        if (!src) return null;

        return (
          <div key={index} style={{ height: "400px", width: "100%" }}>
            <img
              src={src}
              alt={img.getAttribute("alt") || ""}
              className="img-fluid w-100 h-100"
              style={{ objectFit: "contain" }}
            />
          </div>
        );
      }


      return null;
    });
  };
  if (isLoading) {
    return <Loader style={{ height: "100vh", color: "#fff" }} />
  }

  if (isFetched && !testPrepData) return <Cover404 />;


  return (
    <>
      <div
        className="hero-banner"
        style={{
          "--banner-img": `url(${imageBaseApi}${testPrepData?.featuredMedia?.url})`,
        }}
      >
        <SectionContainer>
          <Container fluid className="p-0 m-0">
            <BreadCrumb
              items={[
                { title: "HOME", link: "/" },
                { title: testPrepData?.title.toUpperCase() },
              ]}
              instituition={true}
            
            />

            <div className=" page-content text-start h-100 d-flex flex-column justify-content-center">
              <h1
                className="banner-text-country lh-1"
                style={{
                  color: `#fff`
                }}
              >
                {testPrepData?.title.toUpperCase()}
              </h1>
            </div>
          </Container>
        </SectionContainer>
      </div>
      <SectionContainer>
        <Row className="mb-0">
          <Col>
            {testPrepData?.content && renderContent(testPrepData?.content)}
          </Col>
        </Row>



        <div className="mb-5">
          {/* {WidgetData?.map((widget) => renderWidgetContent(widget?.widget?.description))} */}
          {/* {WidgetData?.filter((item) => item?.isOnshore === false)?.map(
            (item) => (
              <React.Fragment key={item.id}>
                {renderWidgetContent(item?.widget?.description)}
              </React.Fragment>
            ),
          )} */}

          {WidgetData && WidgetData?.map((widget) => {
            const children = widget?.widget?.children || [];

            return (
              <Row key={widget.id} style={{ flexWrap: "nowrap" }}>
                <Col>
                  {children
                    ?.sort((a, b) => a.orderIndex - b.orderIndex)
                    ?.map((item, i) => {
                      const hasUrl = (item?.url && item?.url !== "") || (item?.media?.url !== "" && item?.media?.url);

                      const heading = (
                        <h1
                          className="list-text lh-1"
                          style={{
                            wordBreak: "break-word",
                            overflowWrap: "anywhere",
                            whiteSpace: "normal",
                          }}
                        >
                          {item?.headingName}
                          {hoveredId === item.id && hasUrl && <Link2 size={16} className="ms-1" />}
                        </h1>
                      );

                      return (
                        <React.Fragment key={item.id}>
                          <hr
                            className="line"
                            style={{
                              marginTop: "3.4rem",
                              marginBottom: "2.5rem",
                            }}
                          />

                          {hasUrl ? (
                            <a
                              href={
                                item?.isPdf
                                  ? imageBaseApi + item?.media?.url
                                  : item?.url.startsWith("http")
                                    ? item?.url
                                    : `https://${item?.url}`
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              className="cursor-pointer text-decoration-none"
                              onMouseEnter={() => setHoveredId(item.id)}
                              onMouseLeave={() => setHoveredId(null)}
                            >
                              {heading}
                            </a>
                          ) : (
                            heading
                          )}

                          <p
                            className="country-paragraph-text"
                            style={
                              i === children.length - 1
                                ? { marginBottom: "12.4rem" }
                                : { marginBottom: "0rem" }
                            }
                            dangerouslySetInnerHTML={{ __html: item?.description }}
                            ref={(el) => {
                              if (!el) return;

                              el.querySelectorAll("a").forEach((a) => {
                                a.style.textDecoration = "none";
                                a.style.color = "#7e1790";
                                a.target = "_blank";
                                a.rel = "noopener noreferrer";
                                a.style.position = "relative";

                                let icon;

                                const mouseEnter = () => {
                                  icon = document.createElement("span");
                                  icon.innerHTML = " 🔗";
                                  icon.style.marginLeft = "6px";
                                  icon.className = "hover-link-icon";

                                  a.appendChild(icon);
                                };

                                const mouseLeave = () => {
                                  if (icon && a.contains(icon)) {
                                    a.removeChild(icon);
                                  }
                                };

                                a.addEventListener("mouseenter", mouseEnter);
                                a.addEventListener("mouseleave", mouseLeave);
                              });

                              el.querySelectorAll("p").forEach((p) => {
                                p.style.margin = "0.4rem";
                              });
                            }}
                          />
                        </React.Fragment>
                      );
                    })}
                </Col>
              </Row>
            );
          })}
        </div>


      </SectionContainer>
    </>
  );
};

export default TestPreparation;
